import React from 'react';
import { WifiOff } from 'lucide-react';

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = React.useState(navigator.onLine);

  React.useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="glass-panel bg-red-500/10 border-red-500/20 p-4 rounded-lg shadow-lg flex items-center space-x-2">
        <WifiOff className="w-4 h-4 text-red-400" />
        <p className="text-sm text-red-400">You're offline</p>
      </div>
    </div>
  );
}